export default {"src":"/_next/static/media/CPS.ef6f30cf.svg","height":18,"width":18};